import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shortform-sign-up__other-way" }

import { computed } from 'vue'
import type { SocialAuthComponentView } from '@/models/auth/social'

import FormError from '@/components/ui/FormError.vue'
import GoogleSignInButton from './GoogleSignInButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import AppleSignInButton from './AppleSignInButton.vue'
import { AuthMode, type GoogleButtonLayout } from '@/models/auth/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialAuth',
  props: {
    view: {},
    authMode: {},
    googleButtonLayout: { default: 'default' },
    showGoogle: { type: Boolean, default: true },
    showFacebook: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

// Keep the old public instance shape for unit-test page objects.
__expose({ socialView: props.view })

const socialButtonTitle = computed(() => {
  return props.authMode === AuthMode.Signin ? 'Sign in with' : 'Sign up with'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormError, {
      errors: __props.view.validation.errors,
      field: "social"
    }, null, 8, ["errors"]),
    (__props.showGoogle)
      ? (_openBlock(), _createBlock(GoogleSignInButton, {
          key: 0,
          authMode: __props.authMode,
          buttonLayout: __props.googleButtonLayout,
          view: __props.view.googleAuthView
        }, null, 8, ["authMode", "buttonLayout", "view"]))
      : _createCommentVNode("", true),
    (__props.showFacebook)
      ? (_openBlock(), _createBlock(FacebookLoginButton, {
          key: 1,
          title: socialButtonTitle.value,
          view: __props.view.facebookAuthView
        }, null, 8, ["title", "view"]))
      : _createCommentVNode("", true),
    (__props.view.appleAuthView)
      ? (_openBlock(), _createBlock(AppleSignInButton, {
          key: 2,
          view: __props.view.appleAuthView,
          title: socialButtonTitle.value
        }, null, 8, ["view", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})